import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { useSalesManagers } from '@/features/accounts/hooks/useSubscriptionManagers';

interface AmFilterDropdownProps {
  value: string | undefined;
  onChange: (value: string | undefined) => void;
}

export function AmFilterDropdown({ value, onChange }: AmFilterDropdownProps) {
  const { data: salesManagers, isLoading } = useSalesManagers();

  const ams = salesManagers?.filter((sm) => !sm.isFormer);

  return (
    <Select
      value={value ?? 'all'}
      onValueChange={(v) => onChange(v === 'all' ? undefined : v)}
    >
      <SelectTrigger className="w-[220px]">
        <SelectValue placeholder={isLoading ? 'Loading...' : 'All Account Managers'} />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="all">All Account Managers</SelectItem>
        {ams?.map((sm) => (
          <SelectItem key={sm.id} value={sm.id}>
            {sm.name}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
